// ui-panel-registry.js
export const panels = {
  settings: document.getElementById('settings-panel'),
  'setup-profile-create': document.getElementById('setup-profile-create-sheet'),
  'setup-food-create': document.getElementById('setup-food-create-sheet'),
  settings: document.getElementById('settings-panel'),
  'settings-profile-edit': document.getElementById('settings-profile-edit-sheet'),
  'settings-profile-create': document.getElementById('settings-profile-create-sheet'),
  'settings-food-edit': document.getElementById('settings-food-edit-sheet'),
  'settings-food-create': document.getElementById('settings-food-create-sheet'),
  'settings-nick-edit': document.getElementById('settings-nick-edit-sheet'),
  'settings-nick-create': document.getElementById('settings-nick-create-sheet'),
  'settings-feedback-create': document.getElementById('settings-feedback-create-sheet'),
};

/**
 * Returns the live DOM element for the given panel key.
 * Falls back to querying the DOM directly if registry is missing.
 */
export function getPanel(key) {
  return panels[key] || document.getElementById(`${key}-sheet`);
}
